export const buttons = [{
    left : 162,
    top : 182,
    pos : 'left'
}, {
    left : 162,
    top : 203,
    pos : 'left'
}, {
    left : 162,
    top : 232,
    pos : 'left'
}, {
    left : 295,
    top : 135,
    pos : 'right'
}, {
    left : 295,
    top : 182,
    pos : 'right'
}, {
    left : 517,
    top : 147,
    pos : 'top'
}, {
    left : 669,
    top : 148,
    pos : 'top'
}, {
    left : 679,
    top : 297,
    pos : 'bottom'
}, {
    left : 782,
    top : 148,
    pos : 'top'
}, {
    left : 838,
    top : 324,
    pos : 'bottom'
}, {
    left : 610,
    top : 68,
    pos : 'bottom'
}, {
    left : 580,
    top : 329,
    pos : 'bottom'
}, {
    left : 710,
    top : 310,
    pos : 'bottom'
}];
